export class CustomerPublish {
    publish: boolean;
    subject: string;
    body: string;
    recipients: string[];
}
